import React from 'react';
import { filterProps, slottedToComponents } from '../helpers';
import { Props } from '../types';

export const RocheStageHome = ({
  blok,
  getComponent,
  slot,
}: Props): JSX.Element => {
  const { props, slotted } = filterProps(blok);

  if (slot) {
    props.slot = slot;
  }

  return (
    <roche-stage-home {...props}>
      <h1 className="hero__headline" slot="statement">{props.statement}</h1>
      {slottedToComponents(getComponent, slotted)}
    </roche-stage-home>
  );
};
